module.exports = __webpack_public_path__ + "img/practice-2.a7f61446.jpg";